import React from 'react'
import { Dropdown, Segment } from 'semantic-ui-react'

import ValidationStatusIcon from 'shared/components/ValidationStatusIcon'

/**
 *
 * @param {object} props
 * @param {string} props.name
 * @param {string} props.description
 * @param {function} props.onChange
 * @param {string} props.defaultValue
 * @param {import('semantic-ui-react').DropdownItemProps[]} props.options
 * @param {boolean=} props.loading
 * @param {boolean=} props.isError
 * @param {boolean=} props.disabled
 * @param {boolean=} props.dropdownLoading
 */
export default function CustomFieldSelector({
  description,
  disabled,
  isError,
  loading,
  name,
  onChange,
  options,
  defaultValue,
  dropdownLoading,
}) {
  function handleDropdownChange(_, { value }) {
    onChange(value)
  }

  const customFieldOptions = [
    {
      key: 'null',
      text: 'Do not sync',
      value: null,
    },
    ...options,
  ]

  return (
    <Segment>
      <div className="flex flex-wrap leading-none">
        <div className="self-center" style={{ flex: '320px' }}>
          <strong>{name}</strong>
          <span className="text-grey ml-4">{description}</span>
        </div>
        <ValidationStatusIcon isLoading={loading} isError={isError} suppressUntilFirstChange />
        <Dropdown
          key={defaultValue}
          style={{ alignSelf: 'center' }}
          search
          selection
          defaultValue={defaultValue}
          placeholder="Do not sync"
          options={customFieldOptions}
          disabled={disabled}
          onChange={handleDropdownChange}
          loading={dropdownLoading}
        />
      </div>
    </Segment>
  )
}




// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CustomFieldSelector/index.js